import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import DataTable from '../../components/datatable/DataTable';
import Thumbnail from '../../components/thumbnail/Thumbnail';
import { getColumnStyle, COLUMN_STYLE } from '../../components/datatable/util';
import { deleteImage, uploadImage } from '../../redux/projects/projects_actions';

class ProjectUploadImageModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = { files: [], uploading: false };

    const { t } = this.props;

    this.columns = [
      {
        Header: '',
        accessor: 'thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'image',
        ...getColumnStyle(COLUMN_STYLE.text),
      }
    ];
  }

  onDrop(acceptedFiles) {
    this.props.uploadImage(acceptedFiles[0], this.props.project.id);
  }

  onCancel() {
    this.setState({
      files: []
    });
  }

  onDelete(id) {
    this.props.deleteImage(id, this.props.project.id);
  }

  render() {
    const {
      isLoading,
      filteredCount,
      t,
      ...newProps
    } = this.props;

    const { uploading, deleting } = this.props;

    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('upload image')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <section>
            <div className="dropzone">
              <Dropzone
                className="upload-image-section"
                accept=".jpg,.jpeg,.png"
                onDrop={this.onDrop.bind(this)}
                onFileDialogCancel={this.onCancel.bind(this)}
              >
                <p hide={t} >{uploading ? `${t('uploading')}...` : t('drop one thing zone suggestion')}</p>
              </Dropzone>
            </div>
            <br/>
            <div className="card-header">{t('uploaded images')}</div>
            <DataTable
              columns={this.columns}
              data={this.props.project.images}
              onActionDelete={item => this.onDelete(item.original.id)}
              filteredCount={filteredCount}
            />
          </section>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  uploading: state.project.uploading,
  deleting: state.project.deleting,
  errorMessage: state.project.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  deleteImage: (id, projectId) => dispatch(deleteImage(id, projectId)),
  uploadImage: (file, projectId) => dispatch(uploadImage(file, projectId)),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ProjectUploadImageModal)
);



// WEBPACK FOOTER //
// ./src/modal/projects/ProjectUploadImage.js